module.exports = __webpack_public_path__ + "static/media/news-glensfalls.91c93b49.jpg";